import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Discover from "@/pages/Discover";
import LeadsBoard from "@/pages/LeadsBoard";
import LeadDetail from "@/pages/LeadDetail";
import Settings from "@/pages/Settings";
import Layout from "@/components/Layout";

function Protected({ children }) {
    const { user, loading } = useAuth();
    const loc = useLocation();
    if (loading) return <div className="h-screen flex items-center justify-center overline text-muted-foreground">Loading workspace…</div>;
    if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
    return children;
}

function ScrollTop() {
    const { pathname } = useLocation();
    useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
    return null;
}

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <ScrollTop />
                <Toaster position="top-right" richColors />
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/signup" element={<Signup />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route element={<Protected><Layout /></Protected>}>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/discover" element={<Discover />} />
                        <Route path="/pipeline" element={<LeadsBoard />} />
                        <Route path="/leads/:id" element={<LeadDetail />} />
                        <Route path="/settings" element={<Settings />} />
                    </Route>
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
